import { localStorage } from '@muse-web/storages'

import { GOOGLE_ENTRY_OF_TAB_KEY } from '../constants/storageKeys'

import { isGoogleReferrer } from './isGoogleReferrer'

const isHopWithinSite = (nextjsOrigin?: string): boolean => {
    try {
        const { origin } = new URL(document.referrer)

        return origin === window.location.origin || origin === nextjsOrigin
    } catch {
        return false
    }
}

const readStoredEntry = (): boolean | null => {
    try {
        const stored: unknown = localStorage.get(GOOGLE_ENTRY_OF_TAB_KEY, 'sessionStorage')

        return stored === 'true' || stored === 'false' ? stored === 'true' : null
    } catch {
        return null
    }
}

export const isGoogleEntryOfTab = (nextjsOrigin?: string): boolean => {
    if (typeof window === 'undefined') {
        return false
    }

    if (isHopWithinSite(nextjsOrigin)) {
        return readStoredEntry() ?? true
    }

    const isFromGoogle = isGoogleReferrer()

    localStorage.set(GOOGLE_ENTRY_OF_TAB_KEY, String(isFromGoogle), 'sessionStorage')

    return isFromGoogle
}
